import React from "react";
const checkImg = require("../../../assets/media/check.png");
const TicketTile = ({ code, img, name, active, onClick }) => {
  return (
    <div
      className="ticket-tile"
      data-toggle="modal"
      data-target="#edit_ticket_modal"
      onClick={onClick}
    >
      {active !== false && (
        <img src={checkImg} className="status-img" alt="active" />
      )}
      <img src={img} alt="sub ticket" />
      <p>{name}</p>
    </div>
  );
};
export default TicketTile;



// WEBPACK FOOTER //
// ./src/screens/Tasks/components/TicketTile.js